import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { MySnackBarService } from "@core/my-snack-bar.service";
import { IonicModule } from "@ionic/angular";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";

// import { SwiperModule } from "ngx-swiper-wrapper";
import { AngularFireAuthGuard } from "@angular/fire/compat/auth-guard";
import { firebase, firebaseui, FirebaseUIModule } from 'firebaseui-angular';
import { AgeVerificationPage } from "src/app/components/age-verification/age-verification.page";
import { ComponentModule } from "src/app/components/component.module";
import { VoucherRedeemComponent } from "src/app/components/voucher-redeem/voucher-redeem.component";
import { WelcomePage } from "src/app/components/welcome/welcome.page";
import { PublicOnlyGuard } from "src/app/guard/public-only.guard";
import { salesGuard } from "src/app/guard/sales.guard";
import { SjGuard } from "src/app/guard/sj-guard.guard";

import { LoginDataResolverService } from "src/app/services/login-data-resolver.service";
import { SalesFirestoreService } from "src/app/services/sales-firestore.service";
import { FreeRegCompleteProfileComponent } from "./free-reg-complete-profile/free-reg-complete-profile.component";
import { FreeRegStep4bComponent } from "./free-reg-step4b/free-reg-step4b.component";
import { FreeRegStep4dComponent } from "./free-reg-step4d/free-reg-step4d.component";
import { FreeRegStep4gComponent } from "./free-reg-step4g/free-reg-step4g.component";
import { FreeRegStep4jComponent } from "./free-reg-step4j/free-reg-step4j.component";
import { InterimComponent } from "./interim/interim.component";
import { IssueAwardComponent } from "./issue-award/issue-award.component";
import { JackpotTriggerComponent } from "./jackpot-trigger/jackpot-trigger.component";
import { NoThanksPopupComponent } from "./no-thanks-popup/no-thanks-popup.component";
import { PartialRegistrationComponent } from "./partial-registration/partial-registration.component";
import { PaymentPage } from "./payment/payment.page";

export function FirestoreTranslationsLoaderFactory() {
  return new SalesFirestoreService();
}

const routes: Routes = [
  {
    path: "interim",
    component: InterimComponent,
    resolve: { data: LoginDataResolverService },
    canDeactivate: [salesGuard],
  },
  {
    path: "free-reg-step4j",
    component: FreeRegStep4jComponent,
    canActivate: [SjGuard],
    canDeactivate: [salesGuard],
  },
  {
    path: "welcome",
    component: WelcomePage,
    canActivate: [PublicOnlyGuard],
  },
  {
    path: "free-reg-step4h",
    component: AgeVerificationPage,
    canDeactivate: [salesGuard],
  },
  {
    path: "free-reg-step4a",
    loadChildren: () => import("../../offer-card/offer-card.module").then((m) => m.OfferCardPageModule),
    canDeactivate: [salesGuard],
  },
  {
    path: "free-reg-step4d",
    component: FreeRegStep4dComponent,
    canActivate: [SjGuard],
    canDeactivate: [salesGuard],
  },
  {
    path: "free-reg-step4c",
    component: PaymentPage,
    canActivate: [SjGuard],
    canDeactivate: [salesGuard],
  },
  {
    path: "free-reg-step4b",
    component: FreeRegStep4bComponent,
    canActivate: [SjGuard],
    canDeactivate: [salesGuard],
  },
  {
    path: "free-reg-complete-profile",
    component: FreeRegCompleteProfileComponent,
    canActivate: [AngularFireAuthGuard],
    canDeactivate: [salesGuard],
  },
  {
    path: "free-reg-step4g",
    component: FreeRegStep4gComponent,
    canActivate: [AngularFireAuthGuard],
    canDeactivate: [salesGuard],
  },
  {
    path: "partial-registration",
    component: PartialRegistrationComponent,
    resolve: { data: LoginDataResolverService },
    canDeactivate: [salesGuard],
  },
  {
    path: "nothanks",
    component: NoThanksPopupComponent,
  },
];

const isAppleDevice = /Mac|iPhone|iPad|iPod/i.test(navigator?.platform || navigator?.userAgent);
const firebaseUiAuthConfig: firebaseui.auth.Config = {
  signInFlow: 'popup',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    ...(isAppleDevice ? ['apple.com'] : []),
  ],
  tosUrl: '<your-tos-link>',
  privacyPolicyUrl: '<your-privacyPolicyUrl-link>',
  credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO
};

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ComponentModule,
    ReactiveFormsModule,
    ComponentModule,
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: FirestoreTranslationsLoaderFactory,
        },
        defaultLanguage: "en",
        isolate: true,
        extend: true,
    }),
    FirebaseUIModule.forRoot(firebaseUiAuthConfig),
    NoThanksPopupComponent,
    IssueAwardComponent,
    JackpotTriggerComponent,
    VoucherRedeemComponent,
    PartialRegistrationComponent,
],
    exports: [],
    providers: [MySnackBarService],
})
export class SalesModule {}
